import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  deleteStrategy,
  getStrategies,
  updateStrategyStatus,
} from "./strategyStorage";
import "../AlgoTrading.css";

const StrategiesList = () => {
  const navigate = useNavigate();
  const [strategies, setStrategies] = useState(getStrategies);

  const changeStatus = (id, status) => {
    setStrategies(updateStrategyStatus(id, status));
  };

  const remove = (strategy) => {
    if (!window.confirm(`Delete ${strategy.name}?`)) return;
    deleteStrategy(strategy.id);
    setStrategies(getStrategies());
  };

  return (
    <main className="algo-page">
      <header className="algo-page-heading">
        <div><h1>Strategies</h1><p>Create and manage automated trading strategies.</p></div>
        <button className="algo-primary" onClick={() => navigate("/strategies/new/broker")}>
          <i className="fa fa-plus"></i> Create Strategy
        </button>
      </header>

      <section className="algo-content-card">
        {strategies.length === 0 ? (
          <div className="algo-empty">
            <i className="fa fa-bolt"></i>
            <h2>No strategies created</h2>
            <p>Create your first strategy and connect it to a broker account.</p>
            <button className="algo-primary" onClick={() => navigate("/strategies/new/broker")}>Create Strategy</button>
          </div>
        ) : (
          <div className="algo-table-wrap">
            <table className="algo-table">
              <thead><tr><th>Strategy</th><th>Broker</th><th>Symbol</th><th>Mode</th><th>Status</th><th>P&amp;L</th><th>Actions</th></tr></thead>
              <tbody>
                {strategies.map((strategy) => (
                  <tr key={strategy.id}>
                    <td><strong>{strategy.name}</strong><small>{strategy.id}</small></td>
                    <td>{strategy.brokerName || "—"}</td>
                    <td>{strategy.symbol || "—"}</td>
                    <td>{strategy.tradingMode || "PAPER"}</td>
                    <td><span className={`algo-badge algo-badge--${strategy.status.toLowerCase()}`}>{strategy.status}</span></td>
                    <td className={strategy.pnl >= 0 ? "algo-positive" : "algo-negative"}>₹{Number(strategy.pnl || 0).toFixed(2)}</td>
                    <td><div className="algo-row-actions">
                      <button onClick={() => navigate(`/strategies/${strategy.id}`)} title="View"><i className="fa fa-eye"></i></button>
                      {strategy.status !== "ACTIVE" ? (
                        <button onClick={() => changeStatus(strategy.id, "ACTIVE")} title="Start"><i className="fa fa-play"></i></button>
                      ) : (
                        <button onClick={() => changeStatus(strategy.id, "PAUSED")} title="Pause"><i className="fa fa-pause"></i></button>
                      )}
                      <button className="danger" onClick={() => remove(strategy)} title="Delete"><i className="fa fa-trash"></i></button>
                    </div></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </main>
  );
};

export default StrategiesList;
